import authReducer from './auth';
import commonFiltersReducer from './commonFilters';
import permissionsReducer from './permissions';
import triggerUpdateTableData from './triggerUpdateTableData';
const reducers = {
  auth: authReducer,
  permissions: permissionsReducer,
  commonFilters: commonFiltersReducer,
  triggerUpdateTableData: triggerUpdateTableData,
};

export default reducers;
